// Antes y después de la portada y la ficha (ST-10): arrastre, toque y pista.
(() => {
  const comp = document.getElementById('comparador');
  const rango = comp.querySelector('input');
  rango.oninput = e => comp.style.setProperty('--pos', e.target.value + '%');
  /* Pista (14-10-2026, usuario): al entrar en pantalla el corte se desliza a un
     lado y al otro, una vez, para que se vea que se puede arrastrar. Se para si
     la persona lo toca, y no se mueve con «reducir movimiento». */
  let pistaFin = false;
  const pista = () => {
    const tramos = [[50, 28], [28, 72], [72, 50]], dur = 650, t0 = performance.now();
    const paso = () => {
      if (pistaFin) return;
      const t = Math.max(t0, performance.now());
      const i = Math.min(tramos.length - 1, Math.floor((t - t0) / dur)), k = Math.min(1, (t - t0) / dur - i);
      const e = k < .5 ? 2 * k * k : 1 - (-2 * k + 2) ** 2 / 2, [de, a] = tramos[i], v = de + (a - de) * e;
      rango.value = v; comp.style.setProperty('--pos', v + '%');
      if (t - t0 < dur * tramos.length) requestAnimationFrame(paso);
    };
    requestAnimationFrame(paso);
  };
  ['pointerdown', 'touchstart', 'keydown'].forEach(ev => comp.addEventListener(ev, () => pistaFin = true, {passive: true}));
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
    new IntersectionObserver(([e], o) => { if (e.isIntersecting) { o.disconnect(); setTimeout(pista, 300); } }, {threshold: .6}).observe(comp);
  }
  /* Con el dedo: en iOS el control solo se arrastra desde su tirador, que es
     invisible. Se mueve desde cualquier punto si el gesto es horizontal; si es
     vertical, la página sigue haciendo scroll. */
  let toque = null;
  const mover = e => {
    const r = comp.getBoundingClientRect(), v = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100));
    rango.value = v; comp.style.setProperty('--pos', v + '%');
  };
  comp.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') toque = {x: e.clientX, y: e.clientY, arrastra: false}; });
  comp.addEventListener('pointermove', e => {
    if (!toque) return;
    if (!toque.arrastra && Math.abs(e.clientX - toque.x) > 6 && Math.abs(e.clientX - toque.x) > Math.abs(e.clientY - toque.y)) toque.arrastra = true;
    if (toque.arrastra) mover(e);
  });
  comp.addEventListener('pointerup', e => { if (toque && !toque.arrastra && Math.abs(e.clientY - toque.y) < 6) mover(e); toque = null; });
  comp.addEventListener('pointercancel', () => toque = null);
})();
